import { ArtifactStatus } from '../../shared/helpers/transport/cloud-api/types';

export type ConferenceHistoryItem = {
    sessionId: string;
    shortUrlId: string;
    meetingName?: string;
    startedAt: string;
    endedAt: string;
    summarizationStatus?: ArtifactStatus;
    cloudRecordingStatus?: ArtifactStatus;
    hasMeetingReport: boolean;
    hasLocalRecording: boolean;
};

export enum FETCHING_STATUS {
    IN_PROGRESS = 'in-progress',
    ERROR = 'error',
}
